// VNEC v9 — pages/xuat-kho.js
// V9: ton_kho PK = ma_vat_tu; xuat_kho RPC = xuat_kho_v8(ma_vat_tu, so_luong, noi_dung, ly_do)
import { supabase, xuatKho } from '../lib/supabase.js';
import { formatVND } from '../lib/forms.js';
import { ok, err } from '../components/toast.js';

export async function renderXuatKho() {
  window.__pageInit = init;
  return `
    <div class="page">
      <div class="page-header"><h1>Xuất kho</h1></div>
      <div class="card">
        <div class="grid-2-col">
          <div>
            <h3>Tồn kho hiện tại</h3>
            <div class="field">
              <span>Tìm kiếm</span>
              <input type="search" id="kho-search" placeholder="Mã VT hoặc tên...">
            </div>
            <div class="table-wrap">
              <table class="table table-compact" id="inv-table">
                <thead><tr>
                  <th>Mã VT</th><th>Tên</th>
                  <th class="num">Tồn</th><th>ĐVT</th>
                  <th class="num">Giá BQ</th><th></th>
                </tr></thead>
                <tbody><tr><td colspan="6" class="muted center">Đang tải...</td></tr></tbody>
              </table>
            </div>
          </div>
          <div>
            <h3 id="xk-title">Phiếu xuất</h3>
            <div id="xk-form-area">
              <p class="muted">Chọn vật tư bên trái để xuất.</p>
            </div>
          </div>
        </div>
      </div>
    </div>`;
}

async function init() {
  const search = document.getElementById('kho-search');
  let t;
  search.addEventListener('input', () => { clearTimeout(t); t = setTimeout(loadInv, 300); });
  await loadInv();
}

async function loadInv() {
  const tbody = document.querySelector('#inv-table tbody');
  const term = (document.getElementById('kho-search').value || '').toLowerCase();
  const { data, error } = await supabase.from('ton_kho')
    .select('ma_vat_tu, so_luong_ton, gia_bq, gia_tri_ton, vat_tu:vat_tu_catalog(ten_vat_tu, don_vi)')
    .gt('so_luong_ton', 0).order('ma_vat_tu').limit(500);
  if (error) { tbody.innerHTML = `<tr><td colspan="6">Lỗi: ${error.message}</td></tr>`; return; }

  const filtered = (data || []).filter(r =>
    !term || r.ma_vat_tu.toLowerCase().includes(term) ||
    (r.vat_tu?.ten_vat_tu || '').toLowerCase().includes(term)
  );

  if (!filtered.length) { tbody.innerHTML = '<tr><td colspan="6" class="muted center">Kho trống.</td></tr>'; return; }
  tbody.innerHTML = filtered.map(r => `<tr>
    <td><strong>${r.ma_vat_tu}</strong></td>
    <td>${r.vat_tu?.ten_vat_tu || ''}</td>
    <td class="num bold">${formatVND(r.so_luong_ton)}</td>
    <td>${r.vat_tu?.don_vi || ''}</td>
    <td class="num">${formatVND(r.gia_bq)}</td>
    <td><button class="btn btn-primary btn-sm" data-mavt="${r.ma_vat_tu}">Xuất</button></td>
  </tr>`).join('');

  tbody.querySelectorAll('button[data-mavt]').forEach(btn => {
    btn.addEventListener('click', () => showXuatForm(btn.dataset.mavt));
  });
}

async function showXuatForm(maVT) {
  const area = document.getElementById('xk-form-area');
  area.innerHTML = '<p class="muted">Đang tải...</p>';
  const { data: inv } = await supabase.from('ton_kho')
    .select('ma_vat_tu, so_luong_ton, gia_bq, vat_tu:vat_tu_catalog(ten_vat_tu, don_vi)')
    .eq('ma_vat_tu', maVT).maybeSingle();
  if (!inv) { err('Không tìm thấy vật tư'); return; }

  const ten = inv.vat_tu?.ten_vat_tu || '';
  const dvt = inv.vat_tu?.don_vi || '';
  document.getElementById('xk-title').textContent = `Xuất: ${maVT} — ${ten}`;
  area.innerHTML = `
    <div class="info-box">
      <div><strong>Tồn:</strong> ${formatVND(inv.so_luong_ton)} ${dvt}</div>
      <div><strong>Giá BQ:</strong> ${formatVND(inv.gia_bq)}/${dvt || 'đvị'}</div>
    </div>
    <form id="xk-form">
      <label class="field"><span>Khối lượng xuất (tối đa ${formatVND(inv.so_luong_ton)}) *</span>
        <input name="khoi_luong" type="number" step="0.0001" min="0.0001" max="${inv.so_luong_ton}" required>
      </label>
      <label class="field"><span>Nội dung xuất *</span>
        <input name="noi_dung" required placeholder="Xuất cho dự án / hạng mục...">
      </label>
      <label class="field"><span>Lý do / ghi chú</span>
        <textarea name="ly_do" rows="2" placeholder="Thi công theo đợt...">Thi công theo đợt</textarea>
      </label>
      <button type="submit" class="btn btn-primary btn-block">Xuất kho</button>
    </form>`;

  const form = document.getElementById('xk-form');
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    btn.disabled = true; btn.textContent = 'Đang xuất...';
    try {
      const fd = new FormData(form);
      const result = await xuatKho(
        maVT,
        parseFloat(fd.get('khoi_luong')),
        fd.get('noi_dung') || ('Xuất kho ' + maVT),
        fd.get('ly_do') || null
      );
      ok('Đã xuất. Giá BQ áp dụng: ' + formatVND(result?.gia_bq || 0) + ' đ');
      area.innerHTML = '<p class="muted">Đã xuất xong. Chọn vật tư khác để tiếp tục.</p>';
      document.getElementById('xk-title').textContent = 'Phiếu xuất';
      await loadInv();
    } catch (e) {
      err('Lỗi: ' + e.message);
      btn.disabled = false; btn.textContent = 'Xuất kho';
    }
  });
}
